import React from 'react';
import './PlanWayComponent.css';
import {useTranslation} from "react-i18next";

interface WeekPoint {
    week: string;
    isNow?: boolean;
    isAfter?: boolean;
}

export interface PlanWayComponentProps {
    title: string;
    weeks: WeekPoint[];
    onContinue: () => void;
    step: any;
}

export const PlanWayComponent: React.FC<PlanWayComponentProps> = ({
    title,
    weeks,
    onContinue
}) => {
    const { t} = useTranslation()
    return (
        <div className="plan-way">
            <h1 className="plan-way__title">{title}</h1>

            <div className="plan-way__chart">
                <div className="plan-way__readiness">
                    <span className="plan-way__label">Your readiness level</span>
                </div>

                <div className="plan-way__graph">
                    {/* SVG for the curved line */}
                    <svg className="plan-way__curve" viewBox="0 0 300 100" preserveAspectRatio="none">
                        <defs>
                            <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                                <stop offset="0%" stopColor="#EF4444" />
                                <stop offset="33%" stopColor="#FCD34D" />
                                <stop offset="66%" stopColor="#86EFAC" />
                                <stop offset="100%" stopColor="#10B981" />
                            </linearGradient>
                        </defs>
                        <path
                            d="M0,80 C100,70 200,30 300,20"
                            className="plan-way__curve-path"
                        />
                    </svg>

                    {/* Week points */}
                    <div className="plan-way__points">
                        {weeks.map((week, index) => (
                            <div key={index} className="plan-way__point-container">
                                {week.isNow && (
                                    <div className="plan-way__point-label plan-way__point-label--now">
                                        Now
                                    </div>
                                )}
                                {week.isAfter && (
                                    <div className="plan-way__point-label plan-way__point-label--after">
                                        After 4 weeks
                                    </div>
                                )}
                                <div className="plan-way__point-text">{week.week}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <button className="plan-way__continue" onClick={onContinue}>
                {t('continueButtonText')}
            </button>
        </div>
    );
};
